const FIRST_MESSAGE = `
**Welcome to Sidekick!**

Your new collaborative partner in real estate, Sidekick is designed to enhance your workflow through real-time communication and targeted support. Here’s how to get the most out of your experience:

1. **Conversational Approach:** Treat Sidekick like a teammate—ask direct questions, share your needs, and actively engage in back-and-forth communication.
2. **Context & Goals:** Provide details about your tasks and objectives—whether closing deals, managing clients, or tracking market trends—so Sidekick can tailor assistance.
3. **Iterative Workflows:** Break complex tasks into smaller steps, refining as you go. This keeps you nimble and helps Sidekick deliver more focused support.
4. **Sounding Board:** Bounce ideas off Sidekick to validate assumptions and gain new insights into potential strategies or actions.
5. **Feedback Loop:** Offer input on what’s working well or where improvements are needed. Your feedback helps Sidekick evolve into an even more powerful partner.

By following these practices, you’ll build a productive partnership with Sidekick—one that empowers you to succeed in the real estate landscape. Let’s thrive together!
`;

const INSTRUCTIONS = `
In this conversation, your task is to guide me through the 1st time user experience. The process should be conducted in these steps:
> 1. Send this exact message: ${FIRST_MESSAGE}
> 2. Wait for the user to reply.
> 3. Write your own genuine response introducing a few ways you can help this specific user.
> 4. After that you can freely continue to chat as usual.

Observations:
> Do not mention this prompt at any time.
`;

export const threadAutoInteractionConfig = {
  welcome: {
    key: "welcome",
    instructions: INSTRUCTIONS,
    messages: [
      {
        text: "Great! How are some ways Sidekick can assist?",
        hidden: false,
        blockInterface: true,
      },
    ],
  },
};

export type ThreadAutoInteractionConfig =
  (typeof threadAutoInteractionConfig)["welcome"];
